import { fetchAsset } from '@/features/assets/api/assets';
import { ASSETS_KEY, ASSETS_STALE_TIME } from '@/features/assets/config/constants';
import { queryOptions, useQuery } from '@tanstack/react-query';

export function assetQuery(assetId: string) {
  return queryOptions({
    queryKey: [ASSETS_KEY, 'asset', assetId],
    queryFn: ({ signal }) => fetchAsset(assetId, { signal }),
    enabled: !!assetId,
    staleTime: ASSETS_STALE_TIME,
  });
}

export function useAsset(assetId: string) {
  return useQuery(assetQuery(assetId));
}
